"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = exports.mutations = exports.getters = exports.fnMakeDispatches = exports.fnMakeCommits = exports.fnMakeGetters = exports.state = void 0;
var nvuex_1 = require("../plugins/nvuex");
var dev_performance_1 = __importDefault(require("../core/store/dev.performance"));
var MODULE = "alert";
//-------------------------------------------------------------------------------------------------
// state
var _state = function () { return ({
    alertQueue: new Array(),
    show: false,
}); };
exports.state = _state;
function typeGetters(o) {
    return o;
}
var _getters = typeGetters({
    message: function (state) { return (state.alertQueue[0] ? state.alertQueue[0].message : null); },
    hasError: function (state) {
        return state.alertQueue[0] ? state.alertQueue[0].hasError : null;
    },
    persist: function (state) { return (state.alertQueue[0] ? state.alertQueue[0].persist : null); },
});
function fnMakeGetters(store) {
    return (0, nvuex_1.makeGetters)(store, MODULE, _getters);
}
exports.fnMakeGetters = fnMakeGetters;
function typeMutations(o) {
    return o;
}
var _mutations = typeMutations({
    successMessage: function (state, message) {
        state.alertQueue.push({ message: message, hasError: false });
        state.show = true;
    },
    errorMessage: function (state, _a) {
        var message = _a.message, persist = _a.persist;
        state.alertQueue.push({ message: message, hasError: true, persist: persist });
        state.show = true;
    },
    clear: function (state) {
        state.alertQueue.length = 0;
        state.show = false;
    },
    clearOldest: function (state) {
        state.show = false;
        state.alertQueue.shift();
    },
    updateShow: function (state) {
        state.show = state.alertQueue.length > 0;
    },
});
function fnMakeCommits(store) {
    return (0, nvuex_1.makeCommits)(store, MODULE, _mutations);
}
exports.fnMakeCommits = fnMakeCommits;
function typeActions(o) {
    return o;
}
var _actions = typeActions({
    successMessage: function (_a, message) {
        var commit = _a.commit;
        commit("successMessage", message);
    },
    errorMessage: function (_a, message) {
        var commit = _a.commit;
        commit("errorMessage", { message: message });
    },
    applicationError: function (_a, error) {
        try {
            // this.state.global.isDev && console.error(error);
            console.error(error);
        }
        catch (_b) { }
        // const stack = new Error().stack;
        // this.app.$datadog.trackException("applicationError", { error, stack });
        // const i18n = this.app.i18n;
        // const i18nKey = error?.payload?.i18nKey || error?.payload?.response?.data?.i18nKey;
        // const translated = i18nKey && i18n.t(i18nKey);
        // const payloadError = translated && translated !== i18nKey ? translated : "";
        // const show = (key: string) => commit('errorMessage', { message: payloadError || i18n.t(key) });
        // if (error instanceof ApplicationError) {
        //   switch (error.code) {
        //     case ErrorCode.AUTHORIZATION: show("Alert.ApplicationError.AUTHORIZATION"); break;
        //     case ErrorCode.UNEXPECTED: show("Alert.ApplicationError.UNEXPECTED"); break;
        //     case ErrorCode.HTTP_NO_RESPONSE: show("Alert.ApplicationError.HTTP_NO_RESPONSE"); break;
        //     case ErrorCode.HTTP_ERROR_RESPONSE: show("Alert.ApplicationError.HTTP_ERROR_RESPONSE"); break;
        //     case ErrorCode.HTTP_ERROR_404_NOT_FOUND: show("Alert.ApplicationError.HTTP_ERROR_404_NOT_FOUND"); break;
        //     case ErrorCode.HTTP_BAD_REQUEST: show("Alert.ApplicationError.HTTP_BAD_REQUEST"); break;
        //     default: show("Alert.ApplicationError.UnknownError"); break;
        //   }
        // } else {
        //   show("Alert.UnknownError");
        // }
    },
    handleApplicationError: function (_a, _b) {
        var commit = _a.commit, dispatch = _a.dispatch;
        var error = _b.error, handler = _b.handler, persist = _b.persist;
        return __awaiter(this, void 0, void 0, function () {
            var _i, handler_1, h, message, message;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!Array.isArray(handler)) return [3 /*break*/, 5];
                        _i = 0, handler_1 = handler;
                        _c.label = 1;
                    case 1:
                        if (!(_i < handler_1.length)) return [3 /*break*/, 4];
                        h = handler_1[_i];
                        if (!h.matches(error)) return [3 /*break*/, 3];
                        return [4 /*yield*/, h.getMessage(error)];
                    case 2:
                        message = _c.sent();
                        commit("errorMessage", { message: message, persist: persist });
                        return [3 /*break*/, 4];
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                    case 5:
                        if (!handler.matches(error)) return [3 /*break*/, 7];
                        return [4 /*yield*/, handler.getMessage(error)];
                    case 6:
                        message = _c.sent();
                        commit("errorMessage", { message: message, persist: persist });
                        return [3 /*break*/, 8];
                    case 7:
                        dispatch("applicationError", error);
                        _c.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    },
    clear: function (_a) {
        var commit = _a.commit;
        commit("clear");
    },
    clearOldest: function (_a) {
        var commit = _a.commit;
        commit("clearOldest");
        setTimeout(function () {
            commit("updateShow");
        }, 1000);
    },
});
function fnMakeDispatches(store) {
    return (0, nvuex_1.makeDispatches)(store, MODULE, _actions);
}
exports.fnMakeDispatches = fnMakeDispatches;
//-------------------------------------------------------------------------------------------------
// exports
exports.getters = dev_performance_1.default.nWrapGetterTree(MODULE, _getters);
exports.mutations = dev_performance_1.default.nWrapMutationTree(MODULE, _mutations);
exports.actions = dev_performance_1.default.nWrapActionTree(MODULE, _actions);
//-------------------------------------------------------------------------------------------------
//# sourceMappingURL=alert.js.map